export {
  section_job_seekers_desc,
  section_desc_1,
  section_info_list,
  section_log_desc_list,
  section_usage_list,
  accordion_list,
};

const section_job_seekers_desc = [
  "※本キャンペーンは、職務経歴書添削サービス（50,000円税込）の利用者を対象としています。",
  "※職務経歴書作成後、企業からスカウトメールを2通受取、かつ面談を実施した方を対象に、職務経歴書の添削費用50,000円（税込）を全額キャッシュバックいたします。",
  "※キャッシュバックの申請には、該当企業との選考進捗を確認できる書類の提出が必要です。",
  "※本キャンペーンの適用条件および詳細については、こちらの規定をご参照ください。",
];

const section_desc_1 = [
  "転職に自信がなくてもいい。",
  "本当に自分に合った仕事に",
  "出会いたいあなたへ。",
];

const section_info_list = [
  [
    {
      text: "職務経歴書をエージェントに",
      underlined: false,
    },
    {
      text: "相談したが、",
      underlined: false,
    },
    {
      text: "大して修正されず終わった",
      underlined: true,
    },
  ],
  [
    {
      text: "未経験職種 への",
      underlined: true,
    },
    {
      text: "転職を考えているが、",
      underlined: false,
    },
    {
      text: "どう書けばいいのか分からない",
      underlined: true,
    },
  ],
  [
    {
      text: "書き方が分からず、",
      underlined: false,
    },
    {
      text: "ネットのテンプレを",
      underlined: true,
    },
    {
      text: "コピペしてしまう",
      underlined: true,
    },
  ],
  [
    {
      text: "自分の強みが分からず、",
      underlined: false,
    },
    {
      text: "「市場価値がないのでは？」と",
      underlined: true,
    },
    {
      text: "不安になる",
      underlined: false,
    },
  ],
  [
    {
      text: "書類を出しても、",
      underlined: false,
    },
    {
      text: "何社も書類落ちしてしまう",
      underlined: true,
    },
  ],
  [
    {
      text: "ブランクがあり、",
      underlined: true,
    },
    {
      text: "書く内容に困る",
      underlined: false,
    },
  ],
];

const section_log_desc_list = [
  "自分では気づかない深い部分まで掘り下げ、論理のズレを徹底修正。",
  "あなたの魅力を最大化し、通常のエージェントでは",
  "通過できなかった企業への内定を実現！",
  "今すぐあなたの可能性を広げましょう！",
];

const section_usage_list = [
  {
    stepTitle: "STEP 1",
    imageSrc: "/images/add_files.png",
    title: "まずはカンタン３分登録",
    desc: "「添削サービスに申し込む」のボタンから、基本情報を入力してください。",
  },
  {
    stepTitle: "STEP 2",
    imageSrc: "/images/add_files.png",
    title: "職務経歴書を作成",
    desc: "質問に沿って必要事項を埋めていきます。",
  },
  {
    stepTitle: "STEP 3",
    imageSrc: "/images/add_files.png",
    title: "職務経歴書の添削・修正",
    desc: "職務経歴書アドバイザーからのフィードバック内容をもとに書類をブラッシュアップしましょう。PDFでダウンロード頂けます。",
  },
  {
    stepTitle: "STEP 4",
    imageSrc: "/images/add_files.png",
    title: "企業とのマッチング・面接対策",
    desc: "あなたに興味を持った企業からスカウトが届きます。希望者には面接対策も実施。",
  },
];

const accordion_list = [
  {
    question: "求職者の最新情報はどのように確認できますか？",
    answer:
      "最終報告から半年後経過した場合、候補者に更新のリマインドメールを送ります。出来る限り最新な状態なものにします。",
  },
  {
    question: "求職者の個人情報の取り扱いはどうなっていますか？",
    answer:
      "最終報告から半年後経過した場合、候補者に更新のリマインドメールを送ります。出来る限り最新な状態なものにします。",
  },
  {
    question: "具体的なサポートについて教えてください。",
    answer:
      "最終報告から半年後経過した場合、候補者に更新のリマインドメールを送ります。出来る限り最新な状態なものにします。",
  },
  {
    question: "競合との比較した時の強みを教えてください。",
    answer:
      "最終報告から半年後経過した場合、候補者に更新のリマインドメールを送ります。出来る限り最新な状態なものにします。",
  },
];
